import React from "react"
import Section from "./section"
import CDownloadList from "../elements/c_download_list"

const MDownloadList = (props) => {
  // @todo
  // implement and use DFB-UI-Modules-Markup
  return (
    <Section
      baseClass="m-DownloadList"
      className={props.data.bg_color}
      defaultPadding="large"
      data={props.data}
    >
      <div className="m-DownloadList-wrapper">
        <div className="m-DownloadList-container">
          <div className="m-DownloadList-content">
            <h5 className="dfb-Headline dfb-Headline--h5">
              {props.data.headline}
            </h5>
            <CDownloadList {...props} />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MDownloadList
